import React from 'react';
import { useApiLoading } from 'react-reqq-lite';
import * as actions from './actions';

export const useRegister = () => {
  const isRegisterApiLoading = useApiLoading('REGISTRER', 'post');
  const register = React.useCallback((payload, callback) => {
    actions.register(payload, callback);
  }, []);
  return [isRegisterApiLoading, register];
};
